/**
 * Garde unique de l'acces a la vente. L'ecran de vente (PR 1.5a) l'appellera
 * tel quel ; d'ici la, l'ecran qui suit la connexion l'affiche.
 *
 * Ordre des refus (le premier qui s'applique) :
 *   1. poste revoque ;
 *   2. poste suspendu (DISABLED dans l'ERP) : ventes bloquees, donnees gardees ;
 *   2 bis. poste que l'ERP ne reconnait plus (jeton refuse, 401 au battement de
 *      coeur : statut UNKNOWN, garde en memoire jusqu'au redemarrage) ;
 *   3. aucun employe connecte par NIP ;
 *   4. aucun catalogue sur le poste ;
 *   5. catalogue de 72 h et plus sans confirmation d'un responsable.
 */
import { FRESHNESS } from './catalogFreshness';

export const SALE_BLOCK = Object.freeze({
    REVOKED: 'POSTE_REVOQUE',
    SUSPENDED: 'POSTE_SUSPENDU',
    UNKNOWN: 'POSTE_NON_RECONNU',
    NO_SESSION: 'NIP_REQUIS',
    NO_CATALOG: 'CATALOGUE_ABSENT',
    MANAGER_REQUIRED: 'CONFIRMATION_RESPONSABLE',
});

const MESSAGES = {
    [SALE_BLOCK.REVOKED]: 'Ce poste a été désactivé.',
    [SALE_BLOCK.SUSPENDED]: 'Ce poste est suspendu. Les ventes sont bloquées jusqu\'à sa réactivation dans l\'ERP.',
    [SALE_BLOCK.UNKNOWN]: 'L\'ERP ne reconnaît plus ce poste. Appelez le responsable.',
    [SALE_BLOCK.NO_SESSION]: 'Entrez votre NIP.',
    [SALE_BLOCK.NO_CATALOG]: 'Aucun catalogue sur ce poste. Il faut le charger une fois quand Internet fonctionne.',
    [SALE_BLOCK.MANAGER_REQUIRED]: 'Prix de plus de 3 jours : un responsable doit confirmer',
};

/**
 * @param {object} state
 * @param {string|null} state.terminalStatus ACTIVE | DISABLED | REVOKED | UNKNOWN | null
 * @param {object|null} state.session employe connecte
 * @param {{ state: string, managerConfirmed: boolean }} state.freshness app/catalogFreshness.js
 * @returns {{ allowed: boolean, reason: string|null, message: string|null }}
 */
export function evaluateSaleAccess({ terminalStatus, session, freshness }) {
    let reason = null;
    if (terminalStatus === 'REVOKED') reason = SALE_BLOCK.REVOKED;
    else if (terminalStatus === 'DISABLED') reason = SALE_BLOCK.SUSPENDED;
    else if (terminalStatus === 'UNKNOWN') reason = SALE_BLOCK.UNKNOWN;
    else if (!session) reason = SALE_BLOCK.NO_SESSION;
    else if (!freshness || freshness.state === FRESHNESS.MISSING) reason = SALE_BLOCK.NO_CATALOG;
    else if (freshness.state === FRESHNESS.EXPIRED && !freshness.managerConfirmed) reason = SALE_BLOCK.MANAGER_REQUIRED;
    return { allowed: reason === null, reason, message: reason ? MESSAGES[reason] : null };
}
